import { apiRootUrl } from '../assets/constants';
import { showApiErrorAlert } from '../functions/api';

// types
type AzureUserInfo = {
    id_token: string,
    provider_name: string,
    user_claims: {
        typ: string,
        val: string
    }[],
    user_id: string,
}[]

type DbUserInfo = {
    userId: number,
    userName: string,
    email: string,
    rooms: {
        description: string,
        memberCount: number,
        name: string,
        roomId: number,
        thumbnailUrl: string,
    }[],
}

export const getUserInfoFromAzure = (): Promise<AzureUserInfo | void> => {
    const api = "/.auth/me";
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => result)
        .catch((error) => {
            console.log(error);
        });
};

// サインインユーザーの取得
export const getUserInfoFromDb = (email: string): Promise<DbUserInfo | void> => {
    const api = apiRootUrl + "/users/me?email=" + email;
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => result.data)
        .catch((error) => {
            console.log(error);
        });
};

// ユーザーの規約同意状態の変更
export const setUserAgreementStatus = (
    userId: number,
    agreementValue: "agree" | "disagree",
): Promise<"success" | void> => {
    const consent = agreementValue === "agree";
    const api = apiRootUrl + "/users/terms/consent?userId=" + userId + "&consent=" + consent.toString();
    const options = {
        headers: {
            "Content-Type": "application/json",
        },
        method: "PUT",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "規約同意状態の変更");
            }
            // エラー処理
            if (result.status !== 200 && result.status !== 204) {
                throw new Error(result.status);
            }
            // 成功処理
            if (result.status === 200) {
                return "success";
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
